<template>
  <v-container fluid fill-height style="background-color: #ddd">
    <v-row align="center" justify="center">
      <v-col col="12" md="8">
        <v-card class="elevation-10 pa-5 pa-md-10 rounded-xl">
          <v-card-text class="mt-7">
            <iusa-logo lg />
            <div>
              <h6 class="mt-5 mb-5">
                <v-icon color="black"> mdi-key </v-icon>
                <strong> Volver a establecer contraseña </strong>
              </h6>

              <v-form
                v-if="!hasChangedPassword"
                ref="formRef"
                :disabled="isLoading"
                @submit.prevent="onSubmit"
              >
                <v-row align="center" justify="center" class="text-left">
                  <v-col col="12" md="8">
                    <pasword-form
                      :ref="inputsRef"
                      v-model="passwordForm"
                      hide-current-password
                    />

                    <div class="d-flex justify-center">
                      <vue-recaptcha
                        v-if="!recaptchaInDevMode"
                        :sitekey="$googleSitekey"
                        class="g-recaptcha"
                        @verify="onVerify"
                        @expired="onExpired"
                      />
                    </div>

                    <v-btn
                      type="submit"
                      color="#2fd410"
                      class="text-capitalize white--text mt-4"
                      rounded
                      block
                      :disabled="isLoading"
                    >
                      {{ isLoading ? 'Actualizando...' : 'Actualizar' }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>

              <v-alert v-if="hasChangedPassword" type="success" class="mt-4">
                <p>Contraseña Actualizada Correctamente</p>
                <router-link to="/" class="font-weight-bold white--text">
                  Ir a Inicio de Sesión
                </router-link>
              </v-alert>

              <help-banner class="mt-7" />
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import PaswordForm from '@/components/forms/PasswordForm';
  import HelpBanner from '@/components/HelpBanner';
  import IusaLogo from '@/components/IusaLogo';

  import { mapState, mapActions, mapMutations } from 'vuex';
  import recaptcha from '@/mixins/recaptcha';
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    name: 'RecoverPassword',
    components: {
      IusaLogo,
      PaswordForm,
      VueRecaptcha,
      HelpBanner,
    },
    mixins: [recaptcha],
    data() {
      return {
        token: '',
        tokenEmail: '',
        isLoading: false,
        hasChangedPassword: false,
      };
    },
    computed: {
      ...mapState('updatePassword', [
        'passwordForm',
        'updatingPassword',
        'passwordUpdated',
        'hasError',
        'message',
        'messages',
        'successMessage',
      ]),
    },
    created() {
      const { token, tokenM } = this.$route.query;

      if (!token || !tokenM) {
        this.$router.replace('/');
      }

      this.token = token;
      this.tokenEmail = tokenM;
    },
    methods: {
      ...mapActions('updatePassword', ['passwordReset']),
      ...mapMutations('updatePassword', ['SET_VALID_FORM']),
      async onSubmit() {
        if (!this.$refs.formRef.validate()) {
          return;
        }

        this.isLoading = true;

        const { error } = await this.passwordReset({
          token: this.token,
          tokenM: this.tokenEmail,
        });

        if (error) {
          this.$toast.error(error.description);
          this.isLoading = false;
          return;
        }

        this.hasChangedPassword = true;
        this.isLoading = false;
      },
    },
  };
</script>
